import { gql } from '@apollo/client';

// ========== QUERIES ==========

// this is an expensive query. it fetches all the mesh runs for the given
// organization that were "startedAt" within the given date range.
// It involves splitting graph into meshes
// and then fetching mesh runs (which includes instances) for each mesh.
// This query is used to render the list view of Data Pipeline.

export const GET_RECENT_MESH_RUNS = gql`
  query GetRecentMeshRuns(
    $organizationId: UUID!
    $creditFacilitySlugsToHide: [String!]
    $startDate: JSDate
    $endDate: JSDate
  ) {
    meshRuns: getRecentMeshRuns(
      organizationId: $organizationId
      creditFacilitySlugsToHide: $creditFacilitySlugsToHide
      startDate: $startDate
      endDate: $endDate
    )
  }
`;

export const GET_LATEST_MESH_RUN_FOR_IMPLEMENTATION = gql`
  query GetLatestMeshRun($implementationId: UUID!) {
    getLatestMeshRun(implementationId: $implementationId)
  }
`;

// this is much lighter weight query. it fetches just RDFV data for pipeline runs
// for the given borrower organization within the given date range.
// This query is used to render the calendar view of Data Pipeline, where we only
// care about new version of the mesh runs - which is technically same as latest version of
// the pipeline run.
export const GET_BORROWER_PIPELINE_RUNS = gql`
  query GetBorrowerPipelineRuns(
    $borrowerOrganizationId: UUID!
    $startDate: FullDateStr
    $endDate: FullDateStr
  ) {
    getPipelineRuns(
      organizationId: $borrowerOrganizationId
      startDate: $startDate
      endDate: $endDate
    ) {
      reportingDate
      fileVersion
    }
  }
`;

// Returns pipeline runs with the list of artifact IDs that have instances uploaded.
// Used by deliverables to filter out versions where the artifact already exists.
export const GET_PIPELINE_RUNS_WITH_ARTIFACT_IDS = gql`
  query GetPipelineRunsWithArtifactIds(
    $borrowerOrganizationId: UUID!
    $startDate: FullDateStr
    $endDate: FullDateStr
  ) {
    getPipelineRunsWithArtifactIds(
      organizationId: $borrowerOrganizationId
      startDate: $startDate
      endDate: $endDate
    ) {
      reportingDate
      fileVersion
      uploadedArtifactIds
    }
  }
`;

export const GET_MAYBE_COMPLETE_MESH_RUN_RECORD = gql`
  query GetMaybeCompleteMeshRunRecord(
    $meshRunId: String
    $meshRunParams: MeshRunParams
  ) {
    maybeCompleteMeshRunRecord: getCompleteMeshRunRecordIfAvailable(
      meshRunId: $meshRunId
      meshRunParams: $meshRunParams
    )
  }
`;

export const GET_LATEST_MESH_DOCUMENT = gql`
  query GetLatestMeshDocuments(
    $organizationId: UUID!
    $creditFacilitySlugsToHide: [String!]
  ) {
    latestMeshDocuments: getLatestMeshDocuments(
      organizationId: $organizationId
      creditFacilitySlugsToHide: $creditFacilitySlugsToHide
    )
  }
`;

export const GET_DATA_PIPELINE_DOWNLOAD_SIGNED_URLS = gql`
  query getDataPipelineDownloadSignedUrl($serializedParams: String!) {
    downloadUrls: getSignedDownloadUrls(
      feature: "dataPipelineInstanceRecord"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_DATA_PIPELINE_UPLOAD_SIGNED_URL = gql`
  query getDataPipelineUploadSignedUrl($serializedParams: String!) {
    getSignedUploadUrl(
      feature: "getDataPipelineUploadDestination"
      serializedParams: $serializedParams
    ) {
      url
      s3RequestFields
      queryResponseFields
    }
  }
`;

export const REUPLOAD_LOAN_TAPE = gql`
  mutation ReUploadLoanTape(
    $implementationId: UUID!
    $artifactId: UUID!
    $reportingDate: FullDateStr!
    $fileVersion: Int!
    $currentArtifactInstanceId: UUID!
  ) {
    reUploadLoanTape(
      implementationId: $implementationId
      artifactId: $artifactId
      reportingDate: $reportingDate
      fileVersion: $fileVersion
      currentArtifactInstanceId: $currentArtifactInstanceId
    ) {
      response
    }
  }
`;
